import { useEffect } from 'react';
import { messages } from '../../api/endpoints';
import { ScreenError, ScreenLoader, SubScreen } from '../../components/layout/Screens';
import { EmptyState } from '../../components/ui/Bits';
import { useAsync } from '../../hooks/useAsync';
import { useSession } from '../../store/SessionContext';
import { ConversationRow } from './MessagesScreen';
import { t } from '../../i18n';

/**
 * Les demandes de message.
 *
 * Tout le monde peut ecrire une fois a tout le monde depuis son profil.
 * Ce premier message arrive ici, et nulle part ailleurs : une prise de
 * contact ne bouscule pas les conversations qu'on entretient deja.
 *
 * Repondre est le seul geste qui ouvre la conversation — elle rejoint
 * alors la liste principale, des deux cotes. L'ignorer suffit a la
 * laisser ou elle est, et son auteur ne peut rien ajouter.
 *
 * Seules les demandes recues. Celle qu'on envoie reste dans sa propre
 * liste de conversations : c'est notre message, il doit rester quelque
 * part, et cet ecran est une boite d'entree, pas un registre.
 */
export function MessageRequestsScreen() {
  const { user } = useSession();
  /* Ouvrir l'ecran vaut lecture : la pastille s'eteint des l'arrivee. */
  useEffect(() => {
    void messages.markRequestsSeen().catch(() => undefined);
  }, []);
  const { data, loading, error, reload } = useAsync(
    () => messages.requests(),
    [],
    'message-requests',
  );

  return (
    <SubScreen title={t.messages.demandes.titre}>
      {loading && <ScreenLoader />}
      {error && <ScreenError message={error} onRetry={reload} />}

      {data && data.length === 0 && (
        <EmptyState
          title={t.messages.demandes.aucune}
          hint={t.messages.demandes.aucuneAide}
        />
      )}

      {data && data.length > 0 && (
        <div className="ms-list">
          {data.map((conversation) => (
            <ConversationRow
              key={conversation.id}
              conversation={conversation}
              myId={user?.id ?? ''}
            />
          ))}
        </div>
      )}
    </SubScreen>
  );
}
